module.exports = __webpack_public_path__ + "static/media/logo.2d91619d.png";